const questionsList = [
  {
    id: 1,
    question_title:
      "Something isn't working correctly on the Website. What should I do?",
    info: "If you are experiencing issues or problems on our site, please email us at developers@shlebybourbontours.com with a simple description. We greatly appreciate your time!",
  },
  {
    id: 2,
    question_title: "What services does Shelby Bourbon Tours provide?",
    info: "All Bourbon is Whiskey, but not all Whiskey is Bourbon. Being all about Bourbon, SBT is a hub for services like transportation, places to stay, and events, all for the enjoyment of Kentucky bourbon. We will get you from point A to point B, be it from the airport to your stay or from your stay to the distilleries.",
  },
  {
    id: 3,
    question_title: "Why do I have to sign in?",
    info: "You do not have to sign in if you wish to fill out our custom tour form! Go to the CONTACT page and scroll to the CUSTOM TOUR FORM to proceed. However, if you want to book quickly from our selection of tours, you have to sign in to get to our secure checkout. This ensures that you can provide authenticated email, which we use to send you the confirmation and secures your checkout.",
  },
  {
    id: 4,
    question_title:
      "I did not receive confirmation email after checkout, what do I do?",
    info: "If you opted out of providing your email when signing in with your Apple account, you decided not to provide an email; with that, we cannot send you a confirmation at this moment. Please get in touch with us through our CONTACT page, and we will get back to you and send you a confirmation as soon as possible!",
  },
  {
    id: 5,
    question_title: "How do I schedule a tour of the distillery?",
    info: "Let us take care of that for you! Keep in mind most distilleries require reservations months in advance. We require the same type of time frame. Please give us four weeks in advance heads up in the CUSTOM TOUR FORM  of which distilleries you want to tour privately.",
  },
  {
    id: 6,
    question_title:
      "Does Shelby Bourbon Tours offer Military, Law Enforcement, or First Responders discount?",
    info: "Yes, contact us via steven@shelbybourbontours.com and simply request a military discount. We will get back to you as soon as we can with a discount code, which is used at the checkout.",
  },
  {
    id: 7,
    question_title:
      "Up till what time can I cancel a tour? How do I cancel a tour?",
    info: "Contact us through our contact page or by emailing us at steven@shelbybourbontours.com. Please give us a 48-hour notice and receive your money back. Cancellations are easy; if you made a reservation within our PRESELECTED TOURS, email us your name, the date of your tour, and your tour order number. If you made a CUSTOM TOUR reservation, email us: the tour's name and your name. We will confirm your cancellation, and a refund takes about a week to appear on your statement.",
  },
  {
    id: 8,
    question_title: "What are some other Tours available in Kentucky?",
    info: "Here are a few:  1. The Kentucky Bourbon Trail is the major tour provider in Kentucky and is trademarked by the Kentucky Distillers' Association. 2. Mint Julep Tours is an excursion provider for tours and customizable tours.",
  },
  {
    id: 9,
    question_title:
      "How do I advertise my Distillery, Rental, or Event with Shelby Bourbon Tours?",
    info: "Contact us through our primary email: steven@shelbybourbontours.com.",
  },
  {
    id: 10,
    question_title:
      "How long does a one-day tour take, and can you have a multi-day tour?",
    info: "Single-day tours can take up to 8 hours, depending on how many distilleries guests would like to visit. The multi-day tour can be flexible in such that you can have one day full of tours and the next day more relaxing. Remember to save some time to visit fantastic places for food and relaxation. We are flexible and able to make changes on the spot or beforehand. Do not hesitate to contact us.",
  },
  {
    id: 11,
    question_title: "What are the prices of the tour based on?",
    info: "Shelby Bourbon Tour offers services similar to other tour providers located in Louisville, KY. Our prices are designed to provide competitive pricing with an abundance of services and flexibility!",
  },
  {
    id: 12,
    question_title: "Looking to tour New Riff Distilling?",
    info: "Please contact us directly through our CONTACT page if you are looking to tour New Riff Distilling.",
  },
];
export default questionsList;
